export default {"src":"/frontend-static/_next/static/media/purchase.20eaf318.svg","height":447,"width":340,"blurWidth":0,"blurHeight":0};